exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* -------------------------------------------------------------\n  Sass CSS3 Mixins! The Cross-Browser CSS3 Sass Library\n  By: Matthieu Aussaguel, http://www.mynameismatthieu.com, @matthieu_tweets\n\n  List of CSS3 Sass Mixins File to be @imported and @included as you need\n\n  The purpose of this library is to facilitate the use of CSS3 on different browsers avoiding HARD TO READ and NEVER\n  ENDING css files\n\n  note: All CSS3 Properties are being supported by Safari 5\n  more info: http://www.findmebyip.com/litmus/#css3-properties\n\n------------------------------------------------------------- */\n/* Easings (http://easings.net/) */\n.jim-button-page-wrapper .page-title {\n  padding-top: 15px; }\n\n.jim-button-page-wrapper .page-title img {\n  width: 180px; }\n\n.jim-button-page-wrapper .partner-info-bg.quote {\n  margin-top: 60px; }\n\n.jim-button-page-wrapper .partner .zur-website {\n  margin-top: 0;\n  margin-left: 40px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js??ref--2-2!./src/app/pages/jimButton/jimButton.component.scss
// module id = izmL
// module chunks = 0